import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class UnlockFsArea implements SimplePresentation {
    shouldRun(): boolean {
        return (DevilsCrossRoad.model.gameData.mode == GameMode.FREESPIN || DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();
        const featuresActivatedTop: boolean [] = DevilsCrossRoad.model.getFeatureActivatedByArea("top");

        featuresActivatedTop.forEach((bool, index) => {
            if(bool) {
                tl.add(DevilsCrossRoad.freespinUnlockAreas.unlockArea("top", index,false));
            }
        });


        if(DevilsCrossRoad.model.gameData.mode == DevilsCrossRoadGameMode.SUPER_FREESPIN) {
            const featuresActivatedRight: boolean [] = DevilsCrossRoad.model.getFeatureActivatedByArea("right");

            featuresActivatedRight.forEach((bool, index) => {
                if(bool) {
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.unlockArea("right", index,false));
                }
            })
        }

        tl.add(() => controller.finish());
    }

}